import { HUMAN_STACK } from 'types/deck'

import PhatDropdown from 'components/formElements/PhatDropdown'

import { useActions, useAppSelector } from 'app-redux/hooks'
import { setDeckStateAction } from 'app-redux/deck/actions'

import { setLocalStack } from 'services/accountSettings.service'

export const stackOptions = Object.keys(HUMAN_STACK).map(text => ({
  text,
  key: HUMAN_STACK[text],
  value: HUMAN_STACK[text],
}))

type Props = {
  onGroupByChange?: () => void
  className?: string
}

const DeckGroupByDropdown = ({ onGroupByChange, className }: Props) => {
  const stack = useAppSelector(state => state.deck.stack)

  const [setDeckState] = useActions(setDeckStateAction)

  const handleStackChange = (_e: any, { value }: any) => {
    setDeckState({ stack: value })
    setLocalStack(value)

    if (onGroupByChange) onGroupByChange()
  }

  return (
    <PhatDropdown
      fixedMenu
      matchMenuWidthToParent
      header="Group by"
      icon="clone outline"
      value={stack}
      triggerWrapperClassName={className}
      options={stackOptions.map(opt => ({
        label: opt.text,
        id: `${opt.value}`,
        onClick: () => handleStackChange(null, { value: opt.value }),
      }))}
    />
  )
}

export default DeckGroupByDropdown
